export default "__VITE_ASSET__BEI1slll__"